import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from 'src/environments/environment';
import {VehicleBrand} from 'src/app/domain/core/vehicle-brand.model';
import {Credentials} from 'src/app/domain/core/credentials.model';
import {NewCustomerRequest} from 'src/app/domain/data/new-customer-request';
import {CustomerClientResponse, DealerInformation} from '../../domain/data/customer-client-response.data';
import {CustomerClientRequest} from '../../domain/data/customer-client-request.data';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) { }

  getCustomerConsent(brand: VehicleBrand): Observable<CustomerClientResponse>  {
    if (localStorage.getItem(Credentials.credentialsKey)) {
      return this.http.get<CustomerClientResponse>(environment.endpoints.getCustomerConsent + brand.path);
    } else {
      return of(null)
    }
  }

  updateCustomerConsent(brand: VehicleBrand, api: CustomerClientRequest): Observable<boolean> {
    return this.http.put<boolean>(environment.endpoints.getCustomerConsent + brand.path, api);
  }

  confirmCustomerConsent(vehicleBrand: VehicleBrand, verificationtoken: string): Observable<boolean> {
    const url = environment.endpoints.confirmCustomerConsent
      .replace('{brand}', vehicleBrand.uriName)
      .replace('{verificationtoken}', verificationtoken)

    return this.http.get<boolean>(url);
  }

  denyCustomerConsent(vehicleBrand: VehicleBrand, verificationtoken: string): Observable<boolean> {
    const url = environment.endpoints.denyCustomerConsent
      .replace('{brand}', vehicleBrand.uriName)
      .replace('{verificationtoken}', verificationtoken)
    return this.http.get<boolean>(url);
  }

  registerCustomer(
    brand: VehicleBrand,
    recaptchaToken: string,
    request: NewCustomerRequest
  ): Observable<boolean> {
    const url = `${environment.endpoints.getCustomerConsent}/registration/${brand.uriName}/${recaptchaToken}`;
    return this.http.post<boolean>(url, request);
  }

  getDealerInformation(brand: VehicleBrand, recaptchaToken: string): Observable<DealerInformation> {
    return this.http.get<DealerInformation>(environment.endpoints.getCustomerConsent + '/dealerInfo' + brand.path + '/' + recaptchaToken);
  }

  checkVerificationToken(verificationtoken: string) {
    const url = environment.endpoints.checkVerificationToken
      .replace('{verificationtoken}', verificationtoken);

    return this.http.get<boolean>(url);
  }
}
